import { useAuth0 } from '@auth0/auth0-react'
import { useEffect } from 'react'
import { useRecoilState } from 'recoil'
import { tokenState } from '../store/atoms/token'
import { AuthCookieUtils } from '../utils/auth-cookie'

/**
 * AuthSync component handles syncing Auth0 token to server-side cookies
 * This enables authenticated file downloads and other cookie-based auth flows
 */
export const AuthSync = () => {
  const [idToken] = useRecoilState(tokenState)
  const { isAuthenticated, isLoading } = useAuth0()

  useEffect(() => {
    if (isLoading) return

    if (idToken?.__raw) {
      // Sync token to cookie whenever it changes
      AuthCookieUtils.setAuthCookie(idToken.__raw, true).catch((error) => {
        console.error('Failed to sync auth cookie:', error)
      })
    } else if (!isAuthenticated) {
      // Clear cookie when token is removed (logout)
      AuthCookieUtils.clearAuthCookie().catch((error) => {
        console.error('Failed to clear auth cookie:', error)
      })
    }
  }, [idToken, isAuthenticated, isLoading])

  // This component doesn't render anything
  return null
}
